import template from './vacationsAbsencesRouting.html';
import controller from './vacationsAbsencesRouting.controller';
import './vacationsAbsencesRouting.scss';

let vacationsAbsencesRoutingComponent = {
  restrict: 'E',
  bindings: {
    moduleClosed: '<'
  },
  template,
  controller
};

export default vacationsAbsencesRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesRouting/vacationsAbsencesRouting.component.js